// @flow
import React from "react";
import ComparePlayers from "../../components/ComparePlayers";

const ClassicComparePlayers = (props: Object) => {
	return <ComparePlayers is_classic {...props} />;
};

export default ClassicComparePlayers;